import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-emerald-950 text-center text-stone-50" aria-label="Oferta por tiempo limitado" data-id="element-271" data-mp="369pga49jt16e">
      <div className="h-2 w-full bg-amber-500" aria-hidden="true" data-id="element-272" data-mp="31ipjr04ccl4f" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-273" data-mp="31hefz0awbddb">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-amber-300" data-id="element-274" data-mp="3g72j872n0m3o">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-275" data-mp="3b8isltd3mm4z" /> El precio de lanzamiento termina en:
        </p>
        <Countdown light className="mt-5 scale-110" data-id="element-276" data-mp="3p6pionbt3hu3" />
        <p className="mt-7 font-bold text-emerald-100" data-id="element-277" data-mp="3l89qm50vbj9t">Después sube el precio y no vuelve a bajar.</p>

        <div className="mx-auto mt-6 max-w-xl rounded-lg border border-emerald-700 bg-emerald-900 p-4 text-left text-sm" data-id="element-278" data-mp="1uvtysov68gc0">
          <p className="flex items-center justify-between gap-3 font-bold" data-id="element-279" data-mp="1qus2ogwjwke9">
            <span className="inline-flex items-center" data-id="element-280" data-mp="2supkzz0z5rwp">
              <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-red-500" aria-hidden="true" data-id="element-281" data-mp="2xsr4um685v98" />
              Cupos al precio de lanzamiento
            </span>
            <span className="text-amber-300" data-id="element-282" data-mp="32q11omvy1973">Quedan pocos</span>
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-emerald-800" data-id="element-283" data-mp="37k5cxic8s3dz">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-amber-500" data-id="element-284" data-mp="3cgvobsd3qat2" />
          </div>
          <p className="mt-1 text-right text-xs text-emerald-100" data-id="element-285" data-mp="3qg3tr2zuyf5p">66% de los cupos tomados</p>
        </div>
      </div>
      <div className="h-2 w-full bg-amber-500" aria-hidden="true" data-id="element-286" data-mp="1r65bu41nu7p5" />
    </section>;
}